import { render } from "./noticeDetail.vue?vue&type=template&id=3482bf6c&scoped=true"
import script from "./noticeDetail.vue?vue&type=script&lang=js"
export * from "./noticeDetail.vue?vue&type=script&lang=js"

import "./noticeDetail.vue?vue&type=style&index=0&id=3482bf6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3482bf6c"]])

export default __exports__